<template>
  <Card>
    <v-flex d-flex md12>
      <Toolbar>
        <v-flex sm4>
          <span class="mr-4 body-2">String Inverter </span>
        </v-flex>
        <v-flex sm4 text-sm-center>
          <Toggle v-show="view === 'overview'" :modelValue="toggleValue" @toggleValueChange="(val) => toggleValue = val"
            :theme="theme">
            <v-btn v-if="isLive" flat value="live">{{ $t('Live') }}</v-btn>
            <v-btn flat value="average">{{ $t('Average') }}</v-btn>
          </Toggle>
        </v-flex>
        <v-flex sm4 text-sm-right>
          <div class="body-1">
            {{ show_date }}
          </div>
        </v-flex>
      </Toolbar>
    </v-flex>
    <v-layout row wrap>
      <v-flex sm9>
        <StringDataTable v-if="!!selectedDate && view === 'overview'" :chips="chips" :dataView="toggleValue" :date="selectedDate"
          @chipsUpdate="chipsUpdated" />
        <StringGraph v-if="!!selectedDate && view === 'graph'" :chips="chips" :date="selectedDate" :param="chipsObj" />
      </v-flex>
      <v-flex sm3>
        <v-layout column pa-0 ma-0>
          <StringChip :chips="chips" @alterSelectedChannels="alterSelectedChannels"></StringChip>
          <v-flex xs12 text-xs-center pa-0 pt-2>
            <Toggle :modelValue="view" @toggleValueChange="viewHandler" :theme="theme">
              <v-btn flat value="graph">
                <span>{{ $t('Graph') }}</span>
                <v-icon>bar_chart</v-icon>
              </v-btn>
              <v-btn flat value="overview">
                <span>{{ $t('Table') }}</span>
                <v-icon>table_chart</v-icon>
              </v-btn>
            </Toggle>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <a href="#" class="float">
      <img src="../assets/info.png" height="20px" width="20px" class="my-float" />
    </a>
    <div class="label-container">
      <div class="label-text">*NC: {{ $t('Not Connected') }}</div>
    </div>
  </Card>
</template>
<script>
const momentTz = require('moment-timezone')
import moment from 'moment'
import _ from 'lodash'
import StringChip from '@/components/StringInverter/StringInverterCombobox.vue'
import StringGraph from '@/components/StringInverter/StringInverterGraph.vue'
import StringDataTable from '@/components/StringInverter/StringInverterTable.vue'
import { mapGettersMixin } from '@/util/mixin/index'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    StringChip,
    StringGraph,
    StringDataTable
  },
  mixins: [mapGettersMixin],
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      chips: [],
      chipsObj: {},
      toggleValue: 'live',
      view: 'overview',
      filter: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
      activeFilter: {}
    }
  },
  computed: {
    ...mapGetters(['getActivePlantTimezone']),
    selectedDate() {
      return this.activeFilter.Date ? this.activeFilter.Date.from : ''
    },
    // TODO: Remove this when the time of refactoring API
    show_date() {
      return moment(this.selectedDate).format('YYYY/M/D')
    },
    isLive() {
      return this.selectedDate
        ? momentTz().tz(this.getActivePlantTimezone).isSame(this.selectedDate, 'day')
        : true
    }
  },
  mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if (child.type === 'singleDatePicker') {
        const parameters = ['from', 'to']
        parameters.forEach(key => {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        })
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)
  },
  methods: {
    ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT']),
    alterSelectedChannels(payload) {
      this.chips = _.cloneDeep(payload)
      let obj = {}
      payload.forEach((el) => {
        if (obj[el.split('-ch-')[0]]) {
          obj[el.split('-ch-')[0]].push(el.split('-ch-')[1])
        } else {
          obj[el.split('-ch-')[0]] = [el.split('-ch-')[1]]
        }
      })
      this.chipsObj = obj
    },
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true)
      this.SET_SNACKBAR_CONTENT(payload)
    },
    chipsUpdated(payload) {
      this.chips = _.cloneDeep(payload.chips)
      this.chipsObj = payload.chipsObj
    },
    viewHandler(payload) {
      if (payload === 'graph') {
        if (this.chips.length > 0) {
          this.view = 'graph'
        } else {
          this.updateSnackbar({
            icon: 'error',
            message: 'Please select String Inverters in order to check the graph'
          })
        }
      } else if (payload === 'overview') {
        this.view = 'overview'
      }
    }
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    chips: {
      handler() {
        if (this.chips.length === 0) {
          this.view = 'overview'
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.label-container {
  position: fixed;
  bottom: 85px;
  right: 13px;
  display: table;
  visibility: hidden;
}

.label-text {
  color: #fff;
  background: var(--v-primary-darken2);
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
  border-radius: 3px;
}

.float {
  position: fixed;
  width: 40px;
  height: 40px;
  bottom: 40px;
  right: 15px;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  animation: glowing 1500ms infinite;
}

.my-float {
  font-size: 24px;
  margin-top: 8px;
}

a.float + div.label-container {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s ease;
}

a.float:hover + div.label-container {
  visibility: visible;
  opacity: 1;
}

@keyframes glowing {
  0% {
    background-color: var(--v-primary-base);
    box-shadow: 0 0 3px #cbcbcb;
  }

  50% {
    background-color: var(--v-primary-base);
    box-shadow: 0 0 10px grey;
  }

  100% {
    background-color: var(--v-primary-base);
    box-shadow: 0 0 3px #cbcbcb;
  }
}
</style>
